import {useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";

export function useDeleteSirenPhoneCallConfig() {
    const [deleting, setDeleting] = useState(false);

    const deleteConfig = async (id: string) => {
        setDeleting(true);
        try {
            await platformAPI.delete(`api/siren/phone-call-config/${id}`);
        } finally {
            setDeleting(false);
        }
    };

    return {deleteConfig, deleting};
}
